<template>
  <div class="scaleBar">
    <ul class="scale_ul scale_ul_small">
      <li v-for="(item,i) in timeArrS" :key="i"></li>
    </ul>
    <ul class="scale_ul">
      <li v-for="(item,i) in timeArr" :key="i">{{item}}</li>
    </ul>
  </div>
</template>
<script>
/*
 * startTime 进度条最小值
 * endTime 进度条最大值
 * currentTime 对当前值进行双向绑定实时显示拖拽进度
 * */
export default {
  props: {
    startTime: {
      type: [String, Date],
      require: true,
      // default: '2021-01-01 01:00:00'
    },
    endTime: {
      type: [String, Date],
      require: true,
      // default: '2021-01-02 01:00:00'
    },
    intervalS:{
      type: Number,
      default: 60
    },
    interval:{
      type: Number,
      default: 12
    }
  },
  components: {  },
  data() {
    return {
      
    };
  },
  computed: {
    timeArrS:function(){
      let arr=[];
      let totalNumber = moment(this.endTime).valueOf() - moment(this.startTime).valueOf();
      for(let i=0;i<=this.intervalS;i++){
        let scaleTime = moment(this.startTime).valueOf()  +  (totalNumber/this.intervalS)*i
        // arr.push(moment(scaleTime).format("MM-DD HH"))
        arr.push(moment(scaleTime).format("HH:mm"))
      }
      return arr;
    },
    timeArr:function(){
      let arr=[];
      let totalNumber = moment(this.endTime).valueOf() - moment(this.startTime).valueOf();
      for(let i=0;i<=this.interval;i++){
        let scaleTime = moment(this.startTime).valueOf()  +  (totalNumber/this.interval)*i
        // arr.push(moment(scaleTime).format("MM-DD HH"))
        arr.push(moment(scaleTime).format("HH:mm"))
      }
      return arr;
    }
  },
  watch: {
    
  },
  mounted() {
    
  },
  beforeUnmount(){
  },
  methods: {
   
  }
};
</script>
<style scoped lang="scss">
.scaleBar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  
  .scale_ul{
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    overflow: hidden;

    li{
      width: 1px;
      position: relative;
      display: flex;
      justify-content: space-around;
      white-space: nowrap;
      color: grey;
      padding-top: 6px;
      &::before{
        content: '';
        position: absolute;
        left: 50%;
        top: -10px;
        // width: 4px;
        // height: 16px;
        width: 2px;
        height: 10px;
        background: #ffffff;

      }
    }
  }
  .scale_ul_small{
    position: absolute;
    width: 100%;
    li{
      &::before{
        height: 8px;
        background: grey;
      }
      // &:nth-of-type(6n)::before{
      //   background: transparent;
      // }
    }
  }
}
</style>
